export const foodPhotographersStatic = {
  crumbsNav: [
    { id: 1, title: 'Home', link: '/' },
    { id: 2, title: 'Photographers', link: '/photographers/' },
  ],
  tickers: [
    'Food',
    'Photographers',
    'Portfolio',
    'Food',
    'Photographers',
    'Portfolio',
  ],
};
